/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v10.6.6324.28497 (NJsonSchema v8.33.6323.36213) (http://NSwag.org)
// </auto-generated>
//----------------------


/** Based on standard https://tools.ietf.org/html/rfc6749 . */
export interface OAuthMessage {
    /** The client identifier issued to the client during the registration process. */
    client_id?: string | null;
    /** The client secret. The client MAY omit the parameter if the client secret is an empty string. */
    client_secret?: string | null;
    /** The value MUST be one of "code" for requesting an authorization code, "token" for  requesting an access token(implicit grant), or a registered extension value. */
    response_type?: OAuthResponseType | null;
    /** The value of the scope parameter is expressed as a list of space-delimited, case-sensitive strings.The strings are defined by the authorization server. */
    scope?: string | null;
    /** An opaque value used by the client to maintain state between the request and callback.The authorization server includes this value when redirecting the user-agent back to the client. The parameter SHOULD be used for preventing cross-site request forgery. */
    state?: string | null;
    /** After completing its interaction with the resource owner, the authorization server directs the resource owner's user-agent back to the client. */
    redirect_uri?: string | null;
    /** A single ASCII [USASCII] error code. */
    error?: OAuthError | null;
    /** Human-readable ASCII [USASCII] text providing additional information, used to assist the client developer in understanding the error that occurred. */
    error_description?: string | null;
    /** A URI identifying a human-readable web page with information about the error, used to provide the client developer with additional information about the error. */
    error_uri?: string | null;
    /** Requested grant type. */
    grant_type?: OAuthGrantType | null;
    /** The authorization code received from the authorization server. */
    code?: string | null;
    /** The access token issued by the authorization server. */
    access_token?: string | null;
    /** The type of the token issued. */
    token_type?: OAuthTokenType | null;
    /** The lifetime in seconds of the access token.  For example, the value "3600" denotes that the access token will expire in one hour from the time the response was generated. If omitted, the authorization server SHOULD provide the expiration time via other means or document the default value. */
    expires_in?: number | null;
    /** Auth0 connection */
    connection?: string | null;
    /** The resource owner username. */
    username?: string | null;
    /** The resource owner password. */
    password?: string | null;
    /** The refresh token, which can be used to obtain new access tokens. */
    refresh_token?: string | null;
    /** The value of the "assertion" parameter MUST contain a single JWT. */
    assertion?: string | null;
    /** The id token issued by the authorization server. */
    id_token?: string | null;
    /** Salaxy specific onboarding uri. */
    salaxy_onboarding_uri?: string | null;
    /** User interface language. */
    salaxy_language?: string | null;
    /** Users role. */
    salaxy_role?: string | null;
}

/** OAuthGrantType enumeration */
export enum OAuthGrantType {
    Undefined = <any>"undefined", 
    Authorization_code = <any>"authorization_code", 
    Password = <any>"password", 
    Client_credentials = <any>"client_credentials", 
    Refresh_token = <any>"refresh_token", 
    JwtBearer = <any>"jwtBearer", 
}

/** OAuthResponseType enumeration */
export enum OAuthResponseType {
    Undefined = <any>"undefined", 
    Code = <any>"code", 
    Token = <any>"token", 
}

/** OAuthTokenType enumeration */
export enum OAuthTokenType {
    Undefined = <any>"undefined", 
    Bearer = <any>"bearer", 
    Mac = <any>"mac", 
}

/** OAuthError enumeration */
export enum OAuthError {
    Undefined = <any>"undefined", 
    Invalid_request = <any>"invalid_request", 
    Unauthorized_client = <any>"unauthorized_client", 
    Access_denied = <any>"access_denied", 
    Unsupported_response_type = <any>"unsupported_response_type", 
    Invalid_scope = <any>"invalid_scope", 
    Server_error = <any>"server_error", 
    Temporarily_unavailable = <any>"temporarily_unavailable", 
}

/** OAuthSalaxyAuthorizeMode enumeration */
export enum OAuthSalaxyAuthorizeMode {
    Undefined = <any>"undefined", 
    Sign_in = <any>"sign_in", 
    Sign_up = <any>"sign_up", 
}